import { useOutletContext } from "react-router-dom";
import FacebookIcon from "../../../../assets/images/icons/facebook_icon.svg";
import InstagramIcon from "../../../../assets/images/icons/instagram_icon.svg";
import WebSiteIcon from "../../../../assets/images/icons/link_icon.svg";
import LinkedinIcon from "../../../../assets/images/icons/linkedin_icon.svg";
import PhoneIcon from "../../../../assets/images/icons/phone_icon.svg";
import TelephoneIcon from "../../../../assets/images/icons/telephone_icon.svg";
import WhatsappIcon from "../../../../assets/images/icons/whatsapp_icon.svg";
import MailIcon from "../../../../assets/images/icons/mail.svg"; 
import { IServiceProvider } from "../../../../interface/ProfileInterfaces";
import { TitleWithIcon } from "../../../../Share";
 
const ProviderContactInfo = () => {
  const profileData = useOutletContext<IServiceProvider>();

  const getContactKeyIcon = (key: string) => {
    return key === "WebSite"
      ? WebSiteIcon
      : key.startsWith("Telephone")
        ? TelephoneIcon
        : key === "FaceBook"
          ? FacebookIcon
          : key === "WhatsApp"
            ? WhatsappIcon
            : key === "Instagram"
              ? InstagramIcon
              : key === "LinkedIn"
                ? LinkedinIcon
                : key === "Email"
                  ? MailIcon
                  : PhoneIcon;
  };

  return (
    <div className="flex flex-col gap-1">
      {Object.entries(profileData?.Contacts ?? {}).map(([key, value]) => {
        return (
          value && (
            <TitleWithIcon
              key={key}
              title={value}
              icon={getContactKeyIcon(key)}
            />
          )
        );
      })}
    </div>
  );
};

export default ProviderContactInfo;
